import * as Yup from 'yup'

// export const createPromotionSchema = Yup.object().shape({
//   slug: Yup.string()
//     .required('Slug is required')
//     .min(3, 'Slug must be at least 3 characters')
//     .max(30, 'Slug must be at most 30 characters')
//     .matches(/^[a-z0-9]+(?:[_-][a-z0-9]+)*$/, 'Enter a valid url slug')
// })

export const createPromotionSchema = () =>
	Yup.object().shape({
		title: Yup.mixed().required('Title is required'),
		description: Yup.mixed().when(['category', 'redirectUrlToggle'], {
			is: (category, redirectUrlToggle) =>
			  category == null ||
			  category?.toString() === '1' ||
			  (category?.toString() === '3' && !redirectUrlToggle),
			then: () =>
			  Yup.string()
				.required('Description is required')
				.max(100, 'Description must be at most 100 characters'), // 👈 added max
		  }),
		content: Yup.string().when(['category', 'redirectUrlToggle'], {
			is: (category, redirectUrlToggle) =>
				category == null ||
				category?.toString() === '1' ||
				(category?.toString() === '3' && !redirectUrlToggle),
			then: () => Yup.string().required('Content is required'),
		}),
		category: Yup.string().required('Category is required'),
		slug: Yup.string().when(['category', 'redirectUrlToggle'], {
			is: (category, redirectUrlToggle) =>
				category == null ||
				category?.toString() === '1' ||
				(category?.toString() === '3' && !redirectUrlToggle),
			then: () =>
				Yup.string()
					.required('Slug is required')
					.min(3, 'Slug must be at least 3 characters')
					.max(30, 'Slug must be at most 30 characters')
					.matches(/^[a-z0-9]+(?:[_-][a-z0-9]+)*$/, 'Enter a valid url slug'),
		}),
		image: Yup.mixed().when(['category'], {
			is: (category) => category == null || category?.toString() === '1',
			then: () =>
				Yup.string()
					.required('Card Image Required')
					.test(
						'FILE_FORMAT',
						'Uploaded file has unsupported format.',
						(value) =>
							typeof value === 'string'
								? true
								: !value ||
								  (value &&
										[
											'image/png',
											'image/jpeg',
											'image/jpg',
											'image/svg+xml',
										].includes(value.type))
					),
		}),
		url: Yup.string().when(['category', 'redirectUrlToggle'], {
			is: (category, redirectUrlToggle) =>
				category?.toString() === '3' && redirectUrlToggle,
			then: () => Yup.string().required('Redirect Url required'),
		}),
	});


